import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M13.504 11.111c.083-.358 1.163-4.444-.36-5.294s-1.77-.687-4.598-.12c-.857.173-1.636.326-2.297.401m0 0c-1.519.173-2.416-.063-2.223-1.416.826-1.435 1.753-.435 2.223 1.416m0 0c.225.885.345 1.964.3 3.064l.118 6.394"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M6.74 20s-.245-4.97.163-5.162 6.139-1.346 7.309-.357c1.17.988-2.095 1.428-.79 1.894 1.28.467 5.224.495 6.176-.604.109-.137.925-8.457-.136-8.21s-2.15.824-3.836.686"
    />
  </svg>
);
export const FlagIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
